import { atomFamily, selectorFamily } from 'recoil';
import { savedDisplayOperationState } from '../hooks/useDisplayOperation';
import { getProperty } from '../utils/FPEUtils';

const modelLevelFamily = atomFamily({
  key: 'modelLevelFamily',
  default: selectorFamily({
    key: 'modelLevelFamilySelector',
    get:
      (contentsId) =>
      ({ get }) => {
        return getProperty(get(savedDisplayOperationState), `${contentsId}.level.value`) || '0';
      },
  }),
});

export const modelLevelWithID = selectorFamily({
  key: 'modelLevelWithID',
  get:
    (id) =>
    ({ get }) => {
      return get(modelLevelFamily(id));
    },
  set:
    (id) =>
    ({ set }, newValue) => {
      set(modelLevelFamily(id), newValue);
    },
});
